export function KnowledgeFileIcon({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M16.6667 15.8334V14.1667H5.83334C4.45263 14.1667 3.33334 15.0001 3.3972 16.2501M7.33334 18.3334H14C14.9334 18.3334 15.4001 18.3334 15.7567 18.1518C16.0703 17.992 16.3252 17.737 16.485 17.4234C16.6667 17.0669 16.6667 16.6002 16.6667 15.6667V4.33341C16.6667 3.39999 16.6667 2.93328 16.485 2.57676C16.3252 2.26316 16.0703 2.00819 15.7567 1.8484C15.4001 1.66675 14.9334 1.66675 14 1.66675H7.33334C5.93321 1.66675 5.23315 1.66675 4.69837 1.93923C4.22796 2.17892 3.84551 2.56137 3.60583 3.03177C3.33334 3.56655 3.33334 4.26662 3.33334 5.66675V14.3334C3.33334 15.7335 3.33334 16.4336 3.60583 16.9684C3.84551 17.4388 4.22796 17.8212 4.69837 18.0609C5.23315 18.3334 5.93321 18.3334 7.33334 18.3334Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "KnowledgeFileIcon";
